import { render, staticRenderFns } from "./FiscalConfigs.vue?vue&type=template&id=04c9796f&scoped=true"
import script from "./FiscalConfigs.vue?vue&type=script&lang=js"
export * from "./FiscalConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c9796f",
  null
  
)

export default component.exports